export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Are we in a peak period?',
      $formkit: 'radio',
      if: '$incidentForms.type === Factory',
      name: 'factoryPeakPeriod',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Are we close to cut off?',
      $formkit: 'radio',
      if: '$incidentForms.factoryPeakPeriod === no',
      name: 'factoryCutOff',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    // CARDS
    {
      $el: 'section',
      attrs: {},
      children: [
        {
          label: 'Is there a problem with card production?',
          $formkit: 'radio',
          if: '$incidentForms.factoryPeakPeriod === yes || $incidentForms.factoryCutOff === yes || $incidentForms.factoryCutOff === no',
          name: 'factoryCardProduction',
          optionsClass: 'inline',
          options: [
            {
              label: 'Yes',
              value: 'yes',
            },
            {
              label: 'No',
              value: 'no',
            },
          ],
        },
        {
          label: 'Are all card lines affected?',
          $formkit: 'radio',
          if: '$incidentForms.factoryCardProduction == yes',
          name: 'factoryAllCardLines',
          optionsClass: 'inline',
          options: [
            {
              label: 'Yes',
              value: 'yes',
            },
            {
              label: 'No',
              value: 'no',
            },
          ],
        },
      ],
    },
    //GIFTS
    {
      $el: 'section',
      attrs: {},
      children: [
        {
          label: 'Is there a problem with gift production?',
          $formkit: 'radio',
          if: '$incidentForms.factoryCardProduction == no',
          name: 'factoryGiftProduction',
          optionsClass: 'inline',
          options: [
            {
              label: 'Yes',
              value: 'yes',
            },
            {
              label: 'No',
              value: 'no',
            },
          ],
        },
        {
          label: 'Are all gift lines affected?',
          $formkit: 'radio',
          if: '$incidentForms.factoryGiftProduction === yes ',
          name: 'factoryAllGiftLines',
          optionsClass: 'inline',
          options: [
            {
              label: 'Yes',
              value: 'yes',
            },
            {
              label: 'No',
              value: 'no',
            },
          ],
        },
      ],
    },
    {
      label: 'Is there a problem with stock affecting product availability?',
      $formkit: 'radio',
      if: '$incidentForms.factoryGiftProduction === no',
      name: 'factoryStock',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
  ],
}
